// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { TECH_AND_PRODUCT_DEV_REDUCER_KEY } from "..";
import { getPeriodValue } from "./helpers";
import {
  hp_fp_foundersAndPartnersHeaderMonth,
  hp_sm_businessDevelopmentMonths,
  hp_sm_costPerHeadMonth,
  hp_sm_socialMediaAndContentDesignMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "hp_tpd_";

// other revenue keys
export const TECH_AND_PRODUCT_DEV_HEADER_KEY = prefix + "header";
export const HEAD_COUNT_KEY = prefix + "headCount";
export const ENGINEER_KEY = prefix + "engineer";
export const DEVELOPER_KEY = prefix + "developer";
export const UI_UX_DESIGNER_KEY = prefix + "uiuxDesigner";
export const PRODUCT_MANAGEMENT_KEY = prefix + "productManagement";
export const PRODUCT_DESIGN_KEY = prefix + "productManagement";
export const COST_PER_HEAD_KEY = prefix + "costPerHead";

export const hpTechAndProductDevItems = [
  TECH_AND_PRODUCT_DEV_HEADER_KEY,
  HEAD_COUNT_KEY,
  ENGINEER_KEY,
  DEVELOPER_KEY,
  UI_UX_DESIGNER_KEY,
  PRODUCT_MANAGEMENT_KEY,
  PRODUCT_DESIGN_KEY,
  COST_PER_HEAD_KEY,
];

export const initialState = {
  [TECH_AND_PRODUCT_DEV_HEADER_KEY]: {
    title: "Tech & Product & Development",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      // FIXME: HEAD_COUNT_KEY years do not get updated!
      const headCount = Number(
        getReducerFunc(TECH_AND_PRODUCT_DEV_REDUCER_KEY)[
          HEAD_COUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      const costPerHead = getPeriodValue(
        getReducerFunc(TECH_AND_PRODUCT_DEV_REDUCER_KEY)[COST_PER_HEAD_KEY],
        yearKey,
        getReducerFunc
      );

      return headCount * costPerHead;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [HEAD_COUNT_KEY]: {
    title: "Head Count",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < hpTechAndProductDevItems.length - 1; i++) {
        result += getPeriodValue(
          getReducerFunc(TECH_AND_PRODUCT_DEV_REDUCER_KEY)[
            hpTechAndProductDevItems[i]
          ],
          yearKey,
          getReducerFunc
        );
      }
      return result;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [ENGINEER_KEY]: {
    title: "Engineer",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [DEVELOPER_KEY]: {
    title: "Developer",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_socialMediaAndContentDesignMonth,
    years: {
      [years.YEAR_1_KEY]: 2,
      [years.YEAR_2_KEY]: 2,
      [years.YEAR_3_KEY]: 2,
      [years.YEAR_4_KEY]: 2,
      [years.YEAR_5_KEY]: 2,
    },
  },
  [UI_UX_DESIGNER_KEY]: {
    title: "UI/UX Designer",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [PRODUCT_MANAGEMENT_KEY]: {
    title: "Product Management Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [PRODUCT_DESIGN_KEY]: {
    title: "Product Design Team",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_businessDevelopmentMonths,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 1,
      [years.YEAR_3_KEY]: 1,
      [years.YEAR_4_KEY]: 1,
      [years.YEAR_5_KEY]: 1,
    },
  },
  [COST_PER_HEAD_KEY]: {
    title: "Cost per Head",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_sm_costPerHeadMonth,
    years: {
      [years.YEAR_1_KEY]: 2500,
      [years.YEAR_2_KEY]: 2500,
      [years.YEAR_3_KEY]: 2500,
      [years.YEAR_4_KEY]: 2500,
      [years.YEAR_5_KEY]: 2500,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const hpTechAndProductDevReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TECH_PRODUCT_DEV_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_TECH_PRODUCT_DEV_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_TECH_PRODUCT_DEV_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_TECH_PRODUCT_DEV_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default hpTechAndProductDevReducer;
